import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import SubmenuItem from './submenu-item';


function SubmenuList(props) {
  if (!props.submenuitems)
    return null;

  const items = props.submenuitems;
  const submenuItems = items.map(item =>
    // Key should be specified inside the array.
    <SubmenuItem
      key={item.name.toString()}
      value={item} 

      />
  );
  
  return (
    <ul className="animated-fast fadeInUp">
       {submenuItems}
    </ul>
  );
}


class MenuItem extends React.Component {
    render() {
        const translate = this.props.translate;
        const props = this.props;
        return (
			      <li className={ props.value.submenuData ? 'has-dropdown': '' } >
            { /* NavLink click on mobile resolution closes the menu */ }
            <NavLink exact to={ "/"+props.value.link } onClick={ props.closeNav }  className={props.location.pathname === '/article' ? props.value.link === 'blog' ? 'active' : '' : ''}>{ translate(props.value.name) }</NavLink>
            <SubmenuList submenuitems={props.value.submenuData} />
        </li>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

//wrapping components using withRouter for menu active class update
export default withRouter(connect(mapStateToProps)(MenuItem));





// WEBPACK FOOTER //
// ./src/components/menu/menu-item.jsx